import { jsx as w } from "react/jsx-runtime";
import { forwardRef as D } from "react";
import { tv as E } from "tailwind-variants";
const a = E({
  base: [
    "bg-transparent",
    "block",
    "p-2",
    "placeholder-neutral-500",
    "rounded",
    "w-full"
  ],
  variants: {
    isDisabled: {
      true: ["bg-neutral-200"],
      false: ["border border-neutral-200"]
    }
  }
}), s = D(
  ({
    ariaDescribedby: o,
    ariaLabel: l,
    className: i,
    defaultValue: n,
    disabled: r,
    id: u,
    max: p,
    maxLength: b,
    min: m,
    name: c,
    onChange: t,
    placeholder: d,
    rows: f,
    step: x,
    type: e,
    value: g
  }, v) => /* @__PURE__ */ w(
    e === "textarea" ? "textarea" : "input",
    {
      "aria-label": l,
      "aria-describedby": o,
      className: a({ class: i, isDisabled: r }),
      "data-1p-ignore": !0,
      "data-lpignore": !0,
      defaultValue: n,
      disabled: r,
      id: u,
      max: p,
      maxLength: b,
      min: m,
      name: c,
      onChange: (y) => t == null ? void 0 : t(y.target.value),
      placeholder: d,
      ref: v,
      rows: f,
      step: x,
      type: e,
      value: g
    }
  )
);
s.displayName = "TextInput";
s.styles = a;
export {
  s as default
};
